import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { checkRangeDatePrenotazioniFilter } from "../../../functions/checkRangeDate";
import GeneralCustomDateTimePicker from "../../UI/TimePicker/GeneralCustomDateTimePicker";
import { useTranslation } from "react-i18next";

export function DatapickerBoxDisabilita({ disableButton,valueInizio, valueFine, expanded, isActiveRadioButtonUser}) {
  const [valueDataGiornoInizio, setValueDataGiornoInizio] = React.useState(null);
  const [valueDataGiornoFine, setValueDataGiornoFine] = React.useState(null);
  const { t } = useTranslation();
  const { isCorrectRangeData} = checkRangeDatePrenotazioniFilter(valueDataGiornoInizio,valueDataGiornoFine)

  useEffect(() => {
    disableButton(isCorrectRangeData);
  },[valueDataGiornoInizio,valueDataGiornoFine])


  const handleChangeDataInizio = (newValue) => {
    if (newValue !== null) {
        valueInizio(newValue)
      setValueDataGiornoInizio(newValue);
    } else {
      setValueDataGiornoInizio(null);
    }
  };

  const handleChangeDataFine = (newValue) => {
    if (newValue !== null) {
        valueFine(newValue)
      setValueDataGiornoFine(newValue);
    } else {
      ;
      setValueDataGiornoFine(null);
    }
  };

  useEffect(()=> {
    setValueDataGiornoInizio(null);
    setValueDataGiornoFine(null);

  },[expanded,isActiveRadioButtonUser])

  return (
    <React.Fragment>
          <Grid container columnSpacing={3} rowSpacing={5}>
        <Grid item xs={12} lg={6}>
        <GeneralCustomDateTimePicker
              TypeTimePicker={7}
              label={t("Start_Date")}
              valueStart={valueDataGiornoInizio}
              handleChange={handleChangeDataInizio}
              placeholder={t("Booking_date_placeholder_time")}
            />
        </Grid>
        <Grid item xs={12} lg={6}>
        <GeneralCustomDateTimePicker
              TypeTimePicker={7}
              label={t("End_Date")}
              valueStart={valueDataGiornoFine}
              handleChange={handleChangeDataFine}
              placeholder={t("Booking_date_placeholder_time")}
            />
        </Grid>
        </Grid>
    </React.Fragment>
  );
}
